import { AI_CHAT_ENABLED } from "./ai-feature.ts";

const services = [
  ["Unified Communications", "/services/unified-communications"],
  ["Customer Experience", "/services/customer-experience"],
  ["Network Infrastructure", "/services/network-infrastructure"],
  ["Cyber Security", "/services/cyber-security"],
  ["Managed Services & Support", "/services/managed-services-support"],
  ["Artificial Intelligence", "/services/ai"],
  ["Carrier Services", "/services/carrier-services"],
];

export function NavLinks(props: { dropdown?: boolean }) {
  function askAI() {
    const dialog = document.querySelector("dialog.gage-ai-chat") as HTMLDialogElement;
    dialog.showModal();
  }

  const solutionsLink = props.dropdown
    ? (
      <div class="nav-dropdown">
        <a href="/solutions">
          Solutions <svg class="nav-caret" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
        </a>
        <div class="nav-dropdown-menu">
          {services.map(([label, href]) => <a href={href} key={href}>{label}</a>)}
        </div>
      </div>
    )
    : <a href="/solutions">Solutions</a>;

  return (
    <>
      <a href="/">Home</a>
      {/* <a href="/products">Products</a> */}
      {solutionsLink}
      <a href="/industries">Industries</a>
      <a href="/partners">Partners</a>
      <a href="/about">About</a>
      <a href="/blog">Blog</a>
      {AI_CHAT_ENABLED && (
        <a
          href="javascript:void()"
          onClick={askAI}
          style={{ color: "var(--secondary-color)" }}
        >
          Ask AI
        </a>
      )}
    </>
  );
}
